<template>
  <div>
    <div v-for="announcement in announcements" :key="announcement.id">
      <div :class="`alert alert-${announcement.type} m-0 py-1`" :role="announcement.type">
        <button v-if="announcement.allow_close" @click="markAsRead(announcement)" type="button" class="close"
          :data-dismiss="announcement.type" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        {{ announcement.message }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    initial_announcements: {
      type: Array
    },
  },
  data() {
    return {
      announcements: this.initial_announcements
    };
  },
  methods: {
    markAsRead(announcement) {
      let index = this.announcements.indexOf(announcement);
      axios.post(`/api/v1/announcements/${announcement.id}/markAsRead`)
        .then((res) => {
          this.announcements.splice(index, 1);
        });
    }
  }
};
</script>
